var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.915,
    height: 15.812,
    viewBox: "0 0 17.915 15.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-car",
    "data-name": "Icon fa-solid-car",
    d: "M4.443,5.056,3.585,7.508H13.24l-.858-2.451a1.052,1.052,0,0,0-.992-.7H5.435A1.052,1.052,0,0,0,4.443,5.056ZM1.3,7.666l1.157-3.3A3.155,3.155,0,0,1,5.435,2.25H11.39a3.155,3.155,0,0,1,2.977,2.113l1.157,3.3a2.107,2.107,0,0,1,1.3,1.945V15.92a1.05,1.05,0,0,1-1.052,1.052H14.722A1.05,1.05,0,0,1,13.67,15.92V14.343H3.155V15.92A1.05,1.05,0,0,1,2.1,16.972H1.052A1.05,1.05,0,0,1,0,15.92V9.611A2.107,2.107,0,0,1,1.3,7.666Zm2.9,3a1.052,1.052,0,1,0-1.052,1.052A1.052,1.052,0,0,0,4.206,10.663Zm9.464,1.052a1.052,1.052,0,1,0-1.052-1.052A1.052,1.052,0,0,0,13.67,11.714Z",
    transform: "translate(0.545 -1.705)",
    fill: "none",
    stroke: "#19c3b9",
    strokeWidth: 1.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.309a1101404cd7a690a2303cde7047fe.svg";
export { ForwardRef as ReactComponent };